// extracted by mini-css-extract-plugin
export var box = "_59-1";
export var checkboxRow = "_59-8";
export var checked = "_59-2";
export var descriptionSpacer = "_59-a";
export var disabled = "_59-3";
export var icon = "_59-6";
export var input = "_59-0";
export var labelSpacer = "_59-9";
export var medium = "_59-5";
export var small = "_59-4";
export var text = "_59-7";